module.exports = __webpack_public_path__ + "img/hero-lg.b32f4196.png";